"use client";
import { Flex, Heading, Text, Box } from "@chakra-ui/react";
import { LoadingArea } from "@ui/loading/src/loading-area";
import Head from "next/head";
import { Suspense, useState, useEffect } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { AiFillWarning } from "react-icons/ai";

export default function NewsletterConfirmationPage() {
  const [content, setContent] = useState<{
    title: string;
    description: string;
    status: boolean;
  }>();

  useEffect(() => {
    const storedData = sessionStorage.getItem("newsletterConfirmation");

    if (storedData) {
      setContent(JSON.parse(storedData));
    }
  }, []);

  return (
    <>
      <Head>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <Suspense fallback={<LoadingArea h="100vh" w="full" />}>
        {content ? (
          <Flex
            flexDir="column"
            alignItems="center"
            justifyContent="center"
            h="80vh"
            w="full"
          >
            {content.status ? (
              <FaCheckCircle size={62} color="green" />
            ) : (
              <AiFillWarning size={62} color="orange" />
            )}
            <Box
              paddingTop={{
                base: 5,
                lg: 8,
              }}
              textAlign="center"
              w="80%"
            >
              <Heading paddingBottom={5}>{content.title}</Heading>
              <Text>{content.description}</Text>
            </Box>
          </Flex>
        ) : (
          <></>
        )}
      </Suspense>
    </>
  );
}
